import * as React from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";
import { Select } from "components/common";
import { HelpBlock } from "components/bootstrap";
import useProviderModelOptions from "ai-management/hooks/useProviderModelOptions";
import DisabledLabel from "ai-management/model-providers/overview/DisabledLabel";
const FeatureDescription = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
const SelectCell = styled.td`
  min-width: 240px;
  width: 28%;
  vertical-align: top !important;
`;
const FeatureCell = styled.td`
  width: 44%;
  vertical-align: middle !important;
`;
const renderProviderOption = ({ label, disabled }) => /* @__PURE__ */ React.createElement(React.Fragment, null, label, disabled && /* @__PURE__ */ React.createElement(DisabledLabel, null));
const FeatureModelRow = ({ feature, providers }) => {
  var _a, _b;
  const { setFieldValue, values } = useFormikContext();
  const featureValue = values[feature.feature_id];
  const selectedProviderId = (_a = featureValue == null ? void 0 : featureValue.provider) != null ? _a : null;
  const configuredDefault = providers.find(({ is_default }) => is_default);
  const effectiveProviderId = selectedProviderId != null ? selectedProviderId : configuredDefault == null ? void 0 : configuredDefault.provider;
  const {
    providerOptions,
    modelOptions,
    providerPlaceholder,
    modelPlaceholder,
    providersLoading,
    modelsLoading,
    disabledProviderHint
  } = useProviderModelOptions(providers, effectiveProviderId);
  const providerValue = selectedProviderId != null ? selectedProviderId : void 0;
  const modelValue = (_b = featureValue == null ? void 0 : featureValue.model) != null ? _b : void 0;
  const providerField = `${feature.feature_id}.provider`;
  const modelField = `${feature.feature_id}.model`;
  const changeProvider = (provider) => {
    const nextProvider = provider || null;
    if (nextProvider !== selectedProviderId) {
      setFieldValue(providerField, nextProvider, false);
      setFieldValue(modelField, null, false);
    }
  };
  const changeModel = (modelId) => {
    if (modelId && !selectedProviderId && effectiveProviderId) {
      setFieldValue(providerField, effectiveProviderId, false);
    }
    setFieldValue(modelField, modelId || null, false);
  };
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(FeatureCell, null, /* @__PURE__ */ React.createElement("strong", null, feature.display_name), /* @__PURE__ */ React.createElement(FeatureDescription, null, feature.description)), /* @__PURE__ */ React.createElement(SelectCell, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      "aria-label": `Provider for ${feature.display_name}`,
      inputId: `provider-${feature.feature_id}`,
      options: providerOptions,
      value: providerValue,
      onChange: changeProvider,
      disabled: providers.length === 0,
      isLoading: providersLoading,
      placeholder: providerPlaceholder,
      optionRenderer: renderProviderOption,
      valueRenderer: renderProviderOption
    }
  ), disabledProviderHint && /* @__PURE__ */ React.createElement(HelpBlock, null, disabledProviderHint)), /* @__PURE__ */ React.createElement(SelectCell, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      "aria-label": `Model for ${feature.display_name}`,
      inputId: `model-${feature.feature_id}`,
      options: modelOptions,
      value: modelValue,
      onChange: changeModel,
      disabled: !effectiveProviderId || modelOptions.length === 0,
      isLoading: modelsLoading,
      placeholder: modelPlaceholder
    }
  )));
};
export default FeatureModelRow;
